import { render, staticRenderFns } from "./kwanzaRef.vue?vue&type=template&id=be552b2a&scoped=true"
import script from "./kwanzaRef.vue?vue&type=script&lang=js"
export * from "./kwanzaRef.vue?vue&type=script&lang=js"
import style0 from "./kwanzaRef.vue?vue&type=style&index=0&id=be552b2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be552b2a",
  null
  
)

export default component.exports